import Container from "react-bootstrap/Container";
import Accordion from "react-bootstrap/Accordion";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "./Button";

const faqData = [
  {
    id: "0",
    question: "How do I choose the right service?",
    answer:
      "Our expert team will guide you in selecting the perfect service based on your specific needs and requirements. We offer free consultations to understand your project and recommend the best finishing solution.",
  },
  {
    id: "1",
    question: "What industries do you cater to?",
    answer:
      "We serve a wide range of industries, including automotive, aviation, jewelry, furniture, plumbing, military, and many more! Our versatile expertise allows us to handle projects of any scale.",
  },
  {
    id: "2",
    question: "How long does the process take?",
    answer:
      "The turnaround time varies depending on the service, complexity, and volume of your project. Standard projects typically take 3-7 business days. Contact us for an accurate estimate for your specific needs.",
  },
  {
    id: "3",
    question: "What sets you apart from competitors?",
    answer:
      "Our commitment to impeccable quality, 25+ years of experience, state-of-the-art equipment, and unwavering dedication to customer satisfaction is what sets us apart. We treat every project with the same level of care and precision.",
  },
];

const FAQ = () => {
  return (
    <section className="faq-section">
      <Container>
        <Row className="align-items-start">
          <Col lg={4} className="faq-header-col">
            <div className="faq-header-content">
              <span className="section-label">Have Questions?</span>
              <h2 className="section-title">FAQs</h2>
              <p className="faq-description">
                Find answers to commonly asked questions about our electroplating services.
              </p>
              <div className="faq-cta">
                <p className="faq-cta-text">Can't find what you're looking for?</p>
                <Button to="/contact" variant="primary" size="md">
                  Contact Us
                </Button>
              </div>
            </div>
          </Col>
          <Col lg={8} className="faq-content-col">
            <Accordion className="faq-accordion-enhanced" defaultActiveKey="0">
              {faqData.map((faq, index) => (
                <Accordion.Item eventKey={faq.id} key={faq.id} className="faq-item">
                  <Accordion.Header className="faq-header">
                    <span className="faq-number">0{index + 1}</span>
                    <span className="faq-question">{faq.question}</span>
                  </Accordion.Header>
                  <Accordion.Body className="faq-answer">
                    {faq.answer}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FAQ;
